// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__KAQDA","logoImage":"Logo_logoImage__qJHa3"};